export const constructBotFilter = (botId, relativeIds) => {
  if (!relativeIds) return null;

  const sources = relativeIds.sources
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotSource',
            name: 'WgptBotSource',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          queryOperator: 'or',
          attributeModel: 'standard',
        },
      ];
    })
    .flat();
  const sourceChunks = relativeIds.source_chunks
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotSourceChunk',
            name: 'WgptBotSourceChunk',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          queryOperator: 'or',
          attributeModel: 'standard',
        },
      ];
    })
    .flat();
  const tools = relativeIds.tools
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotTool',
            name: 'WgptBotTool',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          queryOperator: 'or',
          attributeModel: 'standard',
        },
      ];
    })
    .flat();
  const workflows = relativeIds.workflows
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotWorkflow',
            name: 'WgptBotWorkflow',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          queryOperator: 'or',
          attributeModel: 'standard',
        },
      ];
    })
    .flat();
  const workflowStages = relativeIds.workflow_stages
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotWorkflowStage',
            name: 'WgptBotWorkflowStage',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          attributeModel: 'standard',
          queryOperator: 'or',
        },
      ];
    })
    .flat();
  const automations = relativeIds.automations
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptAutomation',
            name: 'WgptAutomation',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          attributeModel: 'standard',
          queryOperator: 'or',
        },
      ];
    })
    .flat();
  const evalCriteria = relativeIds.eval_criteria
    .map(id => {
      return [
        {
          attributeKey: 'model',
          filterOperator: 'equal_to',
          values: {
            id: 'WgptBotEvalCriterion',
            name: 'WgptBotEvalCriterion',
          },
          queryOperator: 'and',
          attributeModel: 'standard',
        },
        {
          attributeKey: 'id',
          filterOperator: 'equal_to',
          values: id,
          queryOperator: 'or',
          attributeModel: 'standard',
        },
      ];
    })
    .flat();
  return [
    {
      attributeKey: 'model',
      filterOperator: 'equal_to',
      values: {
        id: 'WgptBot',
        name: 'WgptBot',
      },
      queryOperator: 'and',
      attributeModel: 'standard',
    },
    {
      attributeKey: 'id',
      filterOperator: 'equal_to',
      values: botId,
      queryOperator: 'or',
      attributeModel: 'standard',
    },
    ...sources,
    ...sourceChunks,
    ...tools,
    ...workflows,
    ...workflowStages,
    ...automations,
    ...evalCriteria,
  ];
};
